<div class="container-fluid px-4 pb-4">
    <app-my-score-filter-bar
        [siteDataSource]="siteDataSource"
        [vendorDataSource]="vendorDataSource"
        (filtersChanged)="onFiltersChanged($event)"
        (exportRequested)="onExport()"
    ></app-my-score-filter-bar>

    <!-- Purchase Orders donut + table -->
    <app-doughnut-chart-table
        title="Purchase Orders"
        [slices]="slices"
        [palette]="palette"
        [score]="myScorePercent"
    ></app-doughnut-chart-table>

    <!-- Trending -->
    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <h4 class="mb-0 text-secondary">Trending</h4>
                <dx-select-box
                    [items]="aggregateOptions"
                    [(value)]="aggregateType"
                    valueExpr="value"
                    displayExpr="text"
                    stylingMode="filled"
                    [width]="140"
                    (onValueChanged)="onAggregateChanged()"
                ></dx-select-box>
            </div>
            <dx-chart [dataSource]="trendingData" [rotated]="false">
                <dxi-series argumentField="day" valueField="value" type="bar" [color]="trendingColor" [barPadding]="0.3"></dxi-series>
                <dxi-value-axis [visible]="true" title="Percent %">
                    <dxo-label [format]="{ type: 'fixedPoint', precision: 0 }"></dxo-label>
                </dxi-value-axis>
                <dxo-argument-axis [type]="'continuous'" argumentType="datetime">
                    <dxo-label [visible]="true"></dxo-label>
                    <dxo-grid [visible]="false"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                </dxo-argument-axis>
                <dxo-legend [visible]="false"></dxo-legend>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTrendingTooltip"></dxo-tooltip>
            </dx-chart>
        </div>
    </div>
</div>
